import React, { useState, useRef, useEffect } from "react"
import { Col, Container, Row } from "reactstrap"
import { DataTable } from "primereact/datatable"
import { FilterMatchMode } from "primereact/api"
import { Column } from "primereact/column"
import { Button } from "primereact/button"
import { Dropdown } from "primereact/dropdown"
import { ChevronDownIcon } from "primereact/icons/chevrondown"
import { ChevronRightIcon } from "primereact/icons/chevronright"
import { Dialog } from "primereact/dialog"
import { InputText } from "primereact/inputtext"
import { Calendar } from "primereact/calendar"
import { InputTextarea } from "primereact/inputtextarea"
import { Checkbox } from "primereact/checkbox"
import { Chips } from "primereact/chips"
import { callReportSourceApi } from "utils/ApiClients"
import { useSelector, useDispatch } from "react-redux"
import { setPageData } from "store/actions"
import { triggerAlert } from "utils/CommonFunctions"
import axios from "axios"

import { menuIdData } from "../../utils/Constants"
import { get_user_menu_permission } from "../../utils/CommonFunctions"
import { error } from "toastr"
import { ProgressSpinner } from "primereact/progressspinner"
import { getCandidateIds } from "./calendarCandidateUtils"

const CalenderActive = () => {
  const dispatch = useDispatch()
  const [addPermission, setAddPermission] = useState(false)
  const [editPermission, setEditPermission] = useState(false)
  const [deletePermission, setDeletePermission] = useState(false)
  const [viewPermission, setViewPermission] = useState(false)
    const [totalRecordsJobs, setTotalRecordsJobs] = useState(0)
  const [totalRecordsContacts, setTotalRecordsContacts] = useState(0)
  const [totalRecordsCandidates, setTotalRecordsCandidates] = useState(0)

  document.title = "ATS - Calender"

  useEffect(() => {
    const menu_id = menuIdData?.AllCalendar
    setAddPermission(get_user_menu_permission(menu_id, "add"))
    setEditPermission(get_user_menu_permission(menu_id, "edit"))
    setDeletePermission(get_user_menu_permission(menu_id, "delete"))
    setViewPermission(get_user_menu_permission(menu_id, "view"))
  }, [])

  const { first, rows, totalRecords } = useSelector(
    state => state.calendar.pagination
  )

  const [selectedEmailOption, setSelectedEmailOption] = useState(null)
  const emailOptions = [
    { label: "1 Selected" },
    { label: "2 Selected" },
    { label: "3 Selected" },
    { label: "4 Selected" },
    { label: "5 Selected" },
  ]
  const jobOptions = [
    { name: "Developer", value: "developer" },
    { name: "Designer", value: "designer" },
    { name: "Manager", value: "manager" },
  ]
  const candidateOptions = [
    { name: "Ram", value: "ram" },
    { name: "Sam", value: "sam" },
    { name: "John", value: "john" },
  ]

  const [filteredJobslink, setFilteredJobslink] = useState([])
  const [totalRecordsjob1, setTotalRecordsjob1] = useState(0)
  const [filteredContacts, setFilteredContacts] = useState([])
  const [filteredCandidates, setFilteredCandidates] = useState([])
  const [jobPage, setJobPage] = useState(1)
  const [jobRows, setJobRows] = useState(10)
  const [jobLazyParams, setJobLazyParams] = useState({ page: 0, rows: 10 });
  const [contactLazyParams, setContactLazyParams] = useState({ page: 0, rows: 10 });
  const [candidateLazyParams, setCandidateLazyParams] = useState({ page: 0, rows: 10 });

  const getjobvallist = async (page,size) => {
    try {
      const response = await axios.get(
        `/api/v1/jobs/?page=${page+1}&size=${size}&status=Approved / Open`,
        {}
      )
      console.log("Jobs API Response:", response.data)
      if (response.data) {
        setFilteredJobslink(response.data.results || [])
        const count =
          response.data.count !== undefined ? response.data.count : 0
        setTotalRecordsJobs(count)
      } else {
        console.log("No data in response")
        setFilteredJobslink([])
        setTotalRecordsJobs(0)
      }
    } catch (error) {
      console.error("Error fetching jobs:", error)
      setFilteredJobslink([])
      setTotalRecordsjob1(0)
    }
  }

  const onJobPageChange = (event) => {
    setJobLazyParams({ page: event.page, rows: event.rows });
  };
  const onContactPageChange = (event) => {
    setContactLazyParams({ page: event.page, rows: event.rows });
  };
  const onCandidatePageChange = (event) => {
    setCandidateLazyParams({ page: event.page, rows: event.rows });
  };

  useEffect(() => {
    getjobvallist(jobLazyParams.page, jobLazyParams.rows);
  }, [jobLazyParams]);

  useEffect(() => {
    getContactList(contactLazyParams.page, contactLazyParams.rows);
  }, [contactLazyParams]);

  useEffect(() => {
    getCandidateList(candidateLazyParams.page, candidateLazyParams.rows);
  }, [candidateLazyParams]);
   

  const selectedEmailTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`}></i>
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-envelope mr-2"></i>
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const emailOptionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`}></i>
        <div>{option.label}</div>
      </div>
    )
  }

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subtype: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subject: { value: null, matchMode: FilterMatchMode.CONTAINS },
    reminder: { value: null, matchMode: FilterMatchMode.EQUALS },
    reminderDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
    startDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
    endDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
    completed: { value: null, matchMode: FilterMatchMode.EQUALS },
    private: { value: null, matchMode: FilterMatchMode.EQUALS },
    user_ids: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    archived: { value: null, matchMode: FilterMatchMode.EQUALS },
    auto_followup: { value: null, matchMode: FilterMatchMode.EQUALS },
    calendar_id: { value: null, matchMode: FilterMatchMode.EQUALS },
    candidate_id: { value: null, matchMode: FilterMatchMode.EQUALS },
    contact_id: { value: null, matchMode: FilterMatchMode.EQUALS },
    created_by: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    description: { value: null, matchMode: FilterMatchMode.CONTAINS },
    end_time: { value: null, matchMode: FilterMatchMode.CONTAINS },
    event_priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    event_time: { value: null, matchMode: FilterMatchMode.CONTAINS },
    external_calendar_event_id: {
      value: null,
      matchMode: FilterMatchMode.EQUALS,
    },
    job_id: { value: null, matchMode: FilterMatchMode.EQUALS },
    recurring: { value: null, matchMode: FilterMatchMode.EQUALS },
    reminder_note: { value: null, matchMode: FilterMatchMode.CONTAINS },
    repeat: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    start_time: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
  })

  const [tableData, setTableData] = useState([])
  const [selectedTableData, setSelectedTableData] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedJobs, setSelectedJobs] = useState([])
  const [job, setJob] = useState(null)
  const [selectedJobTitles, setSelectedJobTitles] = useState("")
  const [jobSearchText, setJobSearchText] = useState("")
  const [jobFilters, setJobFilters] = useState({
    job_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })

  //contacts state
  const [contact, setContact] = useState(null)
  const [selectedContacts, setSelectedContacts] = useState([])
  const [contactDetailsVisible, setContactDetailsVisible] = useState(false)
  const [selectedContactNames, setSelectedContactNames] = useState("")
  const [contactSearchText, setContactSearchText] = useState("")
  const [contactFilters, setContactFilters] = useState({
    first_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })

  //candidate
  const [candidate, setCandidate] = useState(null)
  const [selectedCandidates, setSelectedCandidates] = useState([])
  const [candidateDetailsVisible, setCandidateDetailsVisible] = useState(false)
  const [selectedCandidateNames, setSelectedCandidateNames] = useState("")
  const [candidateSearchText, setCandidateSearchText] = useState("")
  const [candidateFilters, setCandidateFilters] = useState({
    first_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })

  const getContactList = async (page,size) => {
    try {
      const response = await axios.get(
        `/api/v1/contacts/?page=${page+1}&size=${size}&status=Active`,
        {}
      )
      if (response.data) {
        setFilteredContacts(response.data.results)
        setTotalRecordsContacts(response?.data?.count)
      }
      else{
        setFilteredContacts([])
        setTotalRecordsContacts(0)
      }
    } catch (error) {
      console.log("Error fetching contacts:", error)
    }
  }

  const handleSaveContact = () => {
    const selectedContactNames = Array.isArray(selectedContacts)
      ? selectedContacts.map(contact => contact.first_name).join(", ")
      : ""
    setSelectedContactNames(selectedContactNames)
    setContact(
      selectedContacts.length > 0
        ? selectedContacts.map(contact => ({
            name: contact.first_name,
            value: contact.id,
          }))
        : null
    )
    setContactDetailsVisible(false)
    setContactSearchText("")
    setContactFilters({
      first_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    })
  }

  const handleContactIconClick = () => {
    setContactDetailsVisible(true)
  }

  const handleContactRefresh = () => {
    setSelectedContacts([])
    setSelectedContactNames("")
    setContactSearchText("")
    setContactFilters({
      first_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    })
  }

  const getCandidateList = async (page, size) => {
    try {
      const response = await axios.get(
        `/api/v1/candidates/?page=${page+1}&size=${size}&status=Active`,
        {}
      )
      if (response.data) {
        setFilteredCandidates(response?.data?.results)
        setTotalRecordsCandidates(response?.data?.count)
      }
      else{
        setFilteredCandidates([])
        setTotalRecordsCandidates(0)
      }
    } catch (error) {
      console.log("Error fetching candidates:", error)
    }
  }

  const handleCandidateIconClick = () => {
    setCandidateDetailsVisible(true)
  }

  const handleSaveCandidate = () => {
    const selectedCandidateNames = Array.isArray(selectedCandidates)
      ? selectedCandidates.map(candidate => candidate.first_name).join(", ")
      : ""
    setSelectedCandidateNames(selectedCandidateNames)
    setCandidate(
      selectedCandidates.length > 0
        ? selectedCandidates.map(candidate => ({
            name: candidate.first_name,
            value: candidate.candidate_id,
          }))
        : null
    )
    setCandidateDetailsVisible(false)
    setCandidateSearchText("")
    setCandidateFilters({
      first_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    })
  }

  const handleCandidateRefresh = () => {
    setSelectedCandidates([])
    setSelectedCandidateNames("")
    setCandidateSearchText("")
    setCandidateFilters({
      first_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    })
  }

// const fetchAllCanlendersList = async (page = 1) => {
//   try {
//     const response = await callReportSourceApi(`/?page=${page}&size=${rows}`)
//     const apiData = response.data.results
//     dispatch(
//       setPageData({
//         first: (page - 1) * rows,
//         rows: rows || 10,
//         totalRecords: response.data.count,
//       })
//     )
//     const transformedData = apiData.map(item => ({
//       id: item.calendar_id,
//       type: item.event_type,
//       subtype: item.event_sub_type,
//       subject: item.subject,
//       reminder: item.reminder ? item.reminder.replace("m", "") : "",
//       reminderDate: item.start_date,
//       startDate: item.start_date,
//       endDate: item.end_date,
//       completed: item.completed,
//       private: item.private,
//       user_ids: Array.isArray(item.user_ids) ? item.user_ids : [],
//       created_by_name: item.created_by_name,
//       archived: item.archived,
//       auto_followup: item.auto_followup,
//       calendar_id: item.calendar_id,
//       candidate_ids: Array.isArray(item.candidate_ids) ? item.candidate_ids : item.candidate_id ? [item.candidate_id] : [],
//       contact_ids: Array.isArray(item.contact_ids) ? item.contact_ids : item.contact_id ? [item.contact_id] : [],
//       created_by: item.created_by ? item.created_by.toString() : "",
//       description: item.description,
//       end_time: item.end_time,
//       event_priority: item.event_priority,
//       event_time: item.event_time ? item.event_time.split("T")[0] : "",
//       external_calendar_event_id: item.external_calendar_event_id,
//       job_ids: Array.isArray(item.job_ids) ? item.job_ids : item.job_id ? [item.job_id] : [],
//       recurring: item.recurring,
//       reminder_note: item.reminder_note,
//       repeat: item.repeat,
//       start_time: item.start_time,
//       status: item.status,
//     }))
//     setTableData(transformedData)
//   } catch (error) {
//     console.log("error", error.message)
//   }
// }
const fetchAllCanlendersList = async (page = 1) => {
  setLoading(true);
  try {
    const response = await callReportSourceApi(`/?active_events=true&page=${page}&size=${rows}`);
    const apiData = response.data.results;
    dispatch(
      setPageData({
        first: (page - 1) * rows,
        rows: rows || 10,
        totalRecords: response.data.count,
      })
    );
    const transformedData = apiData.map(item => {
      const userIds = Array.isArray(item.user_ids) ? item.user_ids : item.user_ids ? [item.user_ids] : [];
      console.log("User IDs for item:", item.calendar_id, userIds); // Debug log
      return {
        id: item.calendar_id,
        type: item.event_type,
        subtype: item.event_sub_type,
        subject: item.subject,
        reminder: item.reminder || "",
        reminderDate: item.start_date,
        startDate: item.start_date,
        endDate: item.end_date,
        completed: item.completed,
        private: item.private,
        user_ids: userIds, // Use the sanitized array
        created_by_name: item.created_by_name,
        archived: item.archived,
        auto_followup: item.auto_followup,
        calendar_id: item.calendar_id,
        candidate_ids: Array.isArray(item.candidate_ids) ? item.candidate_ids : item.candidate_id ? [item.candidate_id] : [],
        contact_ids: Array.isArray(item.contact_ids) ? item.contact_ids : item.contact_id ? [item.contact_id] : [],
        created_by: item.created_by ? item.created_by.toString() : "",
        description: item.description,
        end_time: item.end_time,
        event_priority: item.event_priority,
        event_time: item.event_time ? item.event_time.split("T")[0] : "",
        external_calendar_event_id: item.external_calendar_event_id,
        job_ids: Array.isArray(item.job_ids) ? item.job_ids : item.job_id ? [item.job_id] : [],
        recurring: item.recurring,
        reminder_note: item.reminder_note,
        repeat: item.repeat,
        start_time: item.start_time,
        status: item.status,
      };
    });
    setTableData(transformedData);
    console.log("Transformed Data:", transformedData); 
  } catch (error) {
    console.log("Error fetching calendar data:", error.message);
     setLoading(false);
  } finally {
    setLoading(false);
  }
};

const ensureCandidateInList = async (candidateId) => {
  let candidate = filteredCandidates.find(c => c.candidate_id === candidateId);
  if (!candidate) {
    // Fetch candidate by ID if not present
    try {
      const response = await axios.get(`/api/v1/candidates/${candidateId}/`);
      candidate = response.data;
      setFilteredCandidates(prev => [...prev, candidate]);
    } catch (error) {
      // handle error or ignore
    }
  }
  return candidate;
};


  useEffect(() => {
    fetchAllCanlendersList(1)
    dispatch(setPageData({ first: 0, rows: 10, totalRecords: 0 }))
  }, [])

  const onPage = event => {
    const newPage = Math.floor(event.first / event.rows) + 1
    dispatch(
      setPageData({
        first: event.first,
        rows: event.rows,
        totalRecords,
      })
    )
    fetchAllCanlendersList(newPage)
  }

  const dt = useRef(null)

  const exportCSV = selectionOnly => {
    dt.current.exportCSV({ selectionOnly })
  }

  const reminderCheckboxTemplate = rowData => {
    const handleCheckboxChange = e => {
      const updatedTableData = tableData.map(item =>
        item.id === rowData.id ? { ...item, reminder: e.target.checked } : item
      )
      setTableData(updatedTableData)
    }

    return (
      <input
        type="checkbox"
        checked={rowData.reminder}
        onChange={handleCheckboxChange}
      />
    )
  }

  const completedCheckboxTemplate = rowData => {
    const handleCheckboxChange = e => {
      const updatedTableData = tableData.map(item =>
        item.id === rowData.id ? { ...item, completed: e.target.checked } : item
      )
      setTableData(updatedTableData)
    }

    return (
      <input
        type="checkbox"
        checked={rowData.completed}
        onChange={handleCheckboxChange}
        disabled
      />
    )
  }

  const reminderTemplate = rowData => {
  if (!rowData.reminder) return <span>None</span>;
  // If reminder is like "10m", extract the number and display "10 minutes"
  const match = rowData.reminder.match(/^(\d+)m$/);
  if (match) {
    return <span>{match[1]} minutes</span>;
  }
  return <span>{rowData.reminder}</span>;
};

  const privateCheckboxTemplate = rowData => {
    const handleCheckboxChange = e => {
      const updatedTableData = tableData.map(item =>
        item.id === rowData.id ? { ...item, private: e.target.checked } : item
      )
      setTableData(updatedTableData)
    }

    return (
      <input
        type="checkbox"
        checked={rowData.private}
        onChange={handleCheckboxChange}
        disabled
      />
    )
  }

  const [showConfirmDialog, setShowConfirmDialog] = useState(false)

  const handleDeleteSelected = () => {
    setShowConfirmDialog(true)
  }

  const confirmDelete = async () => {
    try {
      await Promise.all(
        selectedTableData.map(async event => {
          await axios.delete(
            `/api/v1/events/${event.id}/`
          )
        })
      )
      setShowConfirmDialog(false)
      triggerAlert("success", "Events Deleted Successfully")

      setSelectedTableData([])
      const page = Math.floor(first / rows) + 1
      await fetchAllCanlendersList(page)
    } catch (error) {
      triggerAlert("error", error.message)
    } finally {
      setShowConfirmDialog(false)
    }
  }

  const cancelDelete = () => {
    setShowConfirmDialog(false)
  }

  const [interviewpop, SetInterviewpop] = useState(false)
  const [interview, setInterview] = useState("Interview")
  const [subtype, setSubtype] = useState(null)
  const [startdate, setStartdate] = useState(null)
  const [starttime, setStarttime] = useState(null)
  const [popTextares, setPopTextares] = useState("")
  const [subject, setSubject] = useState("")
  const [priority, setPriority] = useState(null)
  const [jobDetailsVisible, setJobDetailsVisible] = useState(false)
  const [searchText, setSearchText] = useState("")

  const typeInterview = [
    { name: "Low", value: "low" },
    { name: "Medium", value: "medium" },
    { name: "High", value: "high" },
  ]
  const [reminder, setReminder] = useState(null)
  const reminderOptions = [
    { name: "0 mins", value: "0" },
    { name: "5 mins", value: "5" },
    { name: "10 mins", value: "10" },
    { name: "15 mins", value: "15" },
    { name: "30 mins", value: "30" },
  ]
  const [repeat, setRepeat] = useState(null)
  const repeatOptions = [
    { name: "Do not repeat", value: "none" },
    { name: "Daily", value: "daily" },
    { name: "Weekly", value: "weekly" },
    { name: "Mon-Fri", value: "mon-fri" },
  ]

  const [followup, setFollowup] = useState(null)
  const followupOptions = [
    { name: "No", value: "no" },
    { name: "Yes", value: "yes" },
    { name: "1 Day", value: "1day" },
    { name: "2 Days", value: "2days" },
    { name: "3 Days", value: "3days" },
    { name: "1 Week", value: "1week" },
  ]

  const [popchecked, setPopchecked] = useState(false)
  const [popchecked2, setPopchecked2] = useState(false)

  const handlePopupCheckbox = e => {
    setPopchecked(e.checked)
  }
  const handlePopupCheckbox2 = e => {
    setPopchecked2(e.checked)
  }

  const [userid, setUserid] = useState([])
  const [uniqueId,setUniqueId] = useState("")
  const customChip = item => {
    return (
      <div>
        <span>{item}</span>
      </div>
    )
  }

  const typeInterview1 = [
    { name: "Low", value: "low" },
    { name: "Medium", value: "medium" },
    { name: "High", value: "high" },
  ]
  const [reminder1, setReminder1] = useState(null)
  const reminderOptions1 = [
    { name: "0 mins", value: "0" },
    { name: "5 mins", value: "5" },
    { name: "10 mins", value: "10" },
    { name: "15 mins", value: "15" },
    { name: "30 mins", value: "30" },
  ]
  const [repeat1, setRepeat1] = useState(null)
  const repeatOptions1 = [
    { name: "Do not repeat", value: "none" },
    { name: "Daily", value: "daily" },
    { name: "Weekly", value: "weekly" },
    { name: "Mon-Fri", value: "mon-fri" },
  ]

  const [followup1, setFollowup1] = useState(null)
  const followupOptions1 = [
    { name: "None", value: "none" },
    { name: "1 Day", value: "1day" },
    { name: "2 Days", value: "2days" },
    { name: "3 Days", value: "3days" },
    { name: "1 Week", value: "1week" },
    { name: "yes", value: "yes" },
  ]

  const [popcheckedread, setPopcheckedread] = useState(false)
  const [popcheckedread2, setPopcheckedread2] = useState(false)

  const [userid1, setUserid1] = useState(["User1"])
  const customChip1 = item => {
    return (
      <div>
        <span>{item}</span>
      </div>
    )
  }

  const [defaultDate] = useState(new Date())
  const [interviewpop1, SetInterviewpop1] = useState(false)
  const [interview1, setInterview1] = useState("Interview")
  const [subtype1, setSubtype1] = useState(typeInterview1[1].value)
  const [startdate1, setStartdate1] = useState(defaultDate)
  const [starttime1, setStarttime1] = useState(null)
  const [popTextares1, setPopTextares1] = useState("")
  const [priority1, setPriority1] = useState(null)
  const [selectedEvent, setSelectedEvent] = useState(null)
  const [enddate, setEnddate] = useState(null)
  const [endtime, setEndtime] = useState(null)

  const handleClearSearchCalenderAll = () => {
    setFilters({
      type: { value: "" },
      subtype: { value: "" },
      subject: { value: "" },
      reminderDate: { value: "" },
      startDate: { value: "" },
      endDate: { value: "" },
      userId: { value: "" },
    })
  }

const handleEditClick = async() => {
  if (selectedTableData.length !== 1) {
    triggerAlert("error", "Please select exactly one event to edit");
    return;
  }

  const event = selectedTableData[0];
  setSelectedEvent(event);
  setInterview(event.type || "Interview");
  setSubtype(event.subtype || null);
  setStartdate(event.startDate ? new Date(event.startDate) : null);
  setStarttime(
    event.start_time
      ? new Date(`1970-01-01T${event.start_time}Z`)
      : null
  );
  setEnddate(event.endDate ? new Date(event.endDate) : null);
  setEndtime(
    event.end_time ? new Date(`1970-01-01T${event.end_time}Z`) : null
  );
  setPopTextares(event.description || "");
  setSubject(event.subject || "");
  setPriority(event.event_priority ? event.event_priority.toLowerCase() : null);
  setReminder(event.reminder ? event.reminder.toString().replace("m", "") : null);
  setRepeat(event.repeat ? event.repeat.toLowerCase() : null);
  setFollowup(event.auto_followup ? event.auto_followup.toLowerCase() : null);
  setPopchecked(event.completed || false);
  setPopchecked2(event.private || false);
  setUserid(Array.isArray(event.user_ids) ? event.user_ids : []);

  // Populate job selections with null check
  const jobIds = Array.isArray(event.job_ids) ? event.job_ids : event.job_id ? [event.job_id] : [];
  const matchingJobs = filteredJobslink.filter((job) =>
    jobIds.includes(job.job_id)
  );
  setSelectedJobs(matchingJobs);
  const jobSelections = matchingJobs.map((job) => ({
    name: job.job_title,
    value: job.job_id,
  }));
  setJob(jobSelections.length > 0 ? jobSelections : null);
  setSelectedJobTitles(jobSelections.map((job) => job.name).join(", "));

  // Populate contact selections with null check
  const contactIds = Array.isArray(event.contact_ids) ? event.contact_ids : event.contact_id ? [event.contact_id] : [];
  const matchingContacts = filteredContacts.filter((contact) =>
    contactIds.includes(contact.id)
  );
  setSelectedContacts(matchingContacts);
  const contactSelections = matchingContacts.map((contact) => ({
    name: contact.first_name,
    value: contact.id,
  }));
  setContact(contactSelections.length > 0 ? contactSelections : null);
  setSelectedContactNames(
    contactSelections.map((contact) => contact.name).join(", ")
  );

  // Populate candidate selections with null check
    const candidateIds = getCandidateIds(event.candidate_ids || event.candidate_id);
  let matchingCandidates = filteredCandidates.filter(candidate =>
    candidateIds.includes(candidate.candidate_id)
  );
  // If not found, try to fetch and add
  if (matchingCandidates.length === 0 && candidateIds.length > 0) {
    const fetched = await Promise.all(candidateIds.map(id => ensureCandidateInList(id)));
    matchingCandidates = fetched.filter(Boolean);
  }
  setSelectedCandidates(matchingCandidates);
  const candidateSelections = matchingCandidates.map(candidate => ({
    name: candidate.first_name,
    value: candidate.candidate_id,
  }));
  setCandidate(candidateSelections.length > 0 ? candidateSelections : null);
  setSelectedCandidateNames(
    candidateSelections.map(candidate => candidate.name).join(", ")
  );

  // Ensure uniqueId is populated for Chips component
  setUniqueId(Array.isArray(event.user_ids) ? event.user_ids : []);

  SetInterviewpop(true);
};

const handleViewClick = async() => {
  if (selectedTableData.length !== 1) {
    triggerAlert("error", "Please select exactly one event to view");
    return;
  }

  const event = selectedTableData[0];
  setSelectedEvent(event);
  setInterview(event.type || "Interview");
  setSubtype(event.subtype || null);
  setStartdate(event.startDate ? new Date(event.startDate) : null);
  setStarttime(
    event.start_time
      ? new Date(`1970-01-01T${event.start_time}Z`)
      : null
  );
  setEnddate(event.endDate ? new Date(event.endDate) : null);
  setEndtime(
    event.end_time ? new Date(`1970-01-01T${event.end_time}Z`) : null
  );
  setPopTextares(event.description || "");
  setSubject(event.subject || "");
  setPriority(event.event_priority ? event.event_priority.toLowerCase() : null);
  setReminder(event.reminder ? event.reminder.toString().replace("m", "") : null);
  setRepeat(event.repeat ? event.repeat.toLowerCase() : null);
  setFollowup(event.auto_followup ? event.auto_followup.toLowerCase() : null);
  setPopchecked(event.completed || false);
  setPopchecked2(event.private || false);
  setUserid(Array.isArray(event.user_ids) ? event.user_ids : []);

  // Populate job selections with null check
  const jobIds = Array.isArray(event.job_ids) ? event.job_ids : event.job_id ? [event.job_id] : [];
  const matchingJobs = filteredJobslink.filter((job) =>
    jobIds.includes(job.job_id)
  );
  setSelectedJobs(matchingJobs);
  const jobSelections = matchingJobs.map((job) => ({
    name: job.job_title,
    value: job.job_id,
  }));
  setJob(jobSelections.length > 0 ? jobSelections : null);
  setSelectedJobTitles(jobSelections.map((job) => job.name).join(", "));

  // Populate contact selections with null check
  const contactIds = Array.isArray(event.contact_ids) ? event.contact_ids : event.contact_id ? [event.contact_id] : [];
  const matchingContacts = filteredContacts.filter((contact) =>
    contactIds.includes(contact.id)
  );
  setSelectedContacts(matchingContacts);
  const contactSelections = matchingContacts.map((contact) => ({
    name: contact.first_name,
    value: contact.id,
  }));
  setContact(contactSelections.length > 0 ? contactSelections : null);
  setSelectedContactNames(
    contactSelections.map((contact) => contact.name).join(", ")
  );

  // Populate candidate selections with null check
const candidateIds = getCandidateIds(event.candidate_ids || event.candidate_id);
  let matchingCandidates = filteredCandidates.filter(candidate =>
    candidateIds.includes(candidate.candidate_id)
  );
  // If not found, try to fetch and add
  if (matchingCandidates.length === 0 && candidateIds.length > 0) {
    const fetched = await Promise.all(candidateIds.map(id => ensureCandidateInList(id)));
    matchingCandidates = fetched.filter(Boolean);
  }
  setSelectedCandidates(matchingCandidates);
  const candidateSelections = matchingCandidates.map(candidate => ({
    name: candidate.first_name,
    value: candidate.candidate_id,
  }));
  setCandidate(candidateSelections.length > 0 ? candidateSelections : null);
  setSelectedCandidateNames(
    candidateSelections.map(candidate => candidate.name).join(", ")
  );

  // Ensure uniqueId is populated for Chips component
  setUniqueId(Array.isArray(event.user_ids) ? event.user_ids : []);

  SetInterviewpop1(true);
};

  const handleSaveTitle = () => {
    const selectedJobTitles = Array.isArray(selectedJobs)
      ? selectedJobs.map(job => job.job_title).join(", ")
      : ""
    setSelectedJobTitles(selectedJobTitles)
    setJob(
      selectedJobs.length > 0
        ? selectedJobs.map(job => ({ name: job.job_title, value: job.job_id }))
        : null
    )
    setJobDetailsVisible(false)
    setJobSearchText("")
    setJobFilters({
      job_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    })
  }

  const handleRefresh = () => {
    setSelectedJobs([])
    setSelectedJobTitles("")
    setJobSearchText("")
    setJobFilters({
      job_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    })
  }

  const handleIconClick = () => {
    setJobDetailsVisible(true)
  }
   useEffect(() => {
          const userInfo = JSON.parse(sessionStorage.getItem("user-info"));
          if (userInfo && userInfo.user_details) {  
              setUniqueId([userInfo.user_details.unique_user_id]);
              console.log("Unique ID set:", [userInfo.user_details.unique_user_id]);
          }
      }, []);
  

const handleSave = async () => {
  if (!selectedEvent) return;

  const updatedEvent = {
    event_type: interview,
    event_sub_type: subtype,
    subject: subject,
    description: popTextares,
    start_date: startdate ? startdate.toISOString().split("T")[0] : null,
    start_time: starttime ? starttime.toISOString().slice(11, 19) : null,
    end_date: enddate ? enddate.toISOString().split("T")[0] : null,
    end_time: endtime ? endtime.toISOString().slice(11, 19) : null,
    reminder: reminder ? `${reminder}m` : null,
    repeat: repeat ? repeat.charAt(0).toUpperCase() + repeat.slice(1) : null,
    auto_followup: followup ? followup : null,
    completed: popchecked,
    private: popchecked2,
    user_ids: Array.isArray(userid) ? userid : [],
    job_id: Array.isArray(job) ? job.map((j) => j.value) : [],
    candidate_id: Array.isArray(candidate) ? candidate.map((c) => c.value) : [],
    contact_id: Array.isArray(contact) ? contact.map((c) => c.value) : [],
  };

  try {
    const response = await axios.put(
      `/api/v1/events/${selectedEvent.calendar_id}/?is_update_flow=true`,
      updatedEvent
    );
    if (response.status === 201 || response.status === 204) {
      triggerAlert("success", "Event Updated Successfully");
      fetchAllCanlendersList(1);
      setTableData((prevData) =>
        prevData.map((item) =>
          item.id === selectedEvent.id
            ? {
                ...item,
                ...updatedEvent,
                created_by_name: item.created_by_name,
                job_id: updatedEvent.job_id,
                candidate_id: updatedEvent.candidate_id,
                contact_id: updatedEvent.contact_id,
              }
            : item
        )
      );
      setSelectedTableData([]);
    } else {
      triggerAlert("warning", error);
    }
  } catch (error) {
    triggerAlert("error", error);
  } finally {
    SetInterviewpop(false);
  }
};

  const descriptionBodyTemplate = rowData => {
    const maxLength = 30
    const description = rowData.description || ""
    const isTruncated = description.length > maxLength
    const truncatedText = isTruncated
      ? description.substring(0, maxLength).replace(/\S*$/, "") + "..."
      : description

    const [isExpanded, setIsExpanded] = useState(false)

    const toggleExpand = e => {
      e.stopPropagation()
      setIsExpanded(!isExpanded)
    }

    return (
      <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
        {isExpanded ? (
          <span>{description}</span>
        ) : (
          <span
            onClick={isTruncated ? toggleExpand : null}
            style={{
              cursor: isTruncated ? "pointer" : "default",
              display: "inline-block",
            }}
            title={isTruncated ? "Click to expand" : ""}
          >
            {truncatedText}
          </span>
        )}
      </div>
    )
  }

  // Handle search input changes
  const handleJobSearch = e => {
    const value = e.target.value
    setJobSearchText(value)
    setJobFilters({
      job_title: { value: value, matchMode: FilterMatchMode.CONTAINS },
    })
  }

  const handleContactSearch = e => {
    const value = e.target.value
    setContactSearchText(value)
    setContactFilters({
      first_name: { value: value, matchMode: FilterMatchMode.CONTAINS },
    })
  }

  const handleCandidateSearch = e => {
    const value = e.target.value
    setCandidateSearchText(value)
    setCandidateFilters({
      first_name: { value: value, matchMode: FilterMatchMode.CONTAINS },
    })
  }

  const filteredJobs = filteredJobslink.filter(job =>
  job.job_title?.toLowerCase().includes(jobSearchText.toLowerCase())
);

// Filter contacts client-side
const filteredContactsList = filteredContacts.filter(contact =>
  contact.first_name?.toLowerCase().includes(contactSearchText.toLowerCase())
);

// Filter candidates client-side
const filteredCandidatesList = filteredCandidates.filter(candidate =>
  candidate.first_name?.toLowerCase().includes(candidateSearchText.toLowerCase())
);

  return (
    <React.Fragment>
      <div className="page-content allact-tabs">
        <Container fluid={true}>
          <div className="page-title-box actjobbread mb-0">
            <Row className="align-items-center pt-3 pb-3 breadcrumb-card action-items">
              <Col md={6} lg={6} className="d-flex align-items-center">
                {selectedTableData.length > 0 && (
                  <>
                    <button
                      type="button"
                      className="btn btn-secondary import-res-btn ms-1 mainbtn me-1"
                    >
                      <i className="fa-regular fa-user me-1"></i>{" "}
                      {selectedTableData.length} selected
                    </button>
                    <div className="action-icons me-2">
                      {viewPermission && (
                        <>
                          {selectedTableData.length >= 2 ? (
                            ""
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary icons-btn ms-1"
                              onClick={handleViewClick}
                            >
                              <i className="pi pi-eye"></i>
                            </button>
                          )}
                        </>
                      )}

                      {editPermission && (
                        <>
                          {selectedTableData.length >= 2 ? (
                            ""
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary icons-btn ms-1 edit"
                              onClick={handleEditClick}
                            >
                              <i className="pi pi-pencil"></i>
                            </button>
                          )}
                        </>
                      )}

                      {deletePermission && (
                        <>
                          <button
                            type="button"
                            className="btn btn-secondary icons-btn ms-1 delete"
                            onClick={handleDeleteSelected}
                          >
                            <i className="pi pi-trash"></i>
                          </button>
                        </>
                      )}
                    </div>
                  </>
                )}
                <div>
                  <button
                    type="button"
                    className="btn btn-secondary import-res-btn ms-1 mainbtn mb-1"
                    onClick={handleClearSearchCalenderAll}
                  >
                    <i className="fa-solid fa-xmark"></i> Clear Search
                  </button>
                </div>
              </Col>
              <Col md={12} lg={4}></Col>
            </Row>
            {loading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 300 }}>
                <ProgressSpinner />
              </div>
            ) :(      
                <Row>
                    <Col lg={12}>
                      <section className="job-datatable-section">
                        <div className="card1 mt-3 mb-4 actjobsumtable datatable-check">
                          <DataTable
                            ref={dt}
                            value={tableData}
                            tableStyle={{
                              minWidth: "50rem",
                              borderRadius: "8px",
                              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                            }}
                            rows={rows}
                            first={first}
                            totalRecords={totalRecords}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            onPage={onPage}
                            dataKey="id"
                            loading={loading}
                            scrollable
                            emptyMessage="No records found."
                            // selection={selectedTableData}
                            // onSelectionChange={e => setSelectedTableData(e.value)}
                            filters={filters}
                            filterDisplay="row"
                            reorderableRows
                            resizableColumns
                            columnResizeMode="expand"
                            onRowClick={e => setSelectedTableData([e.data])}
                          >
                            {/* <Column
                              selectionMode="multiple"
                              headerStyle={{ width: "3em" }}
                            /> */}
                            <Column
                              field="type"
                              header="Type"
                              sortable
                              filter
                              style={{ minWidth: "10rem" }}
                            />
                            <Column
                              field="subtype"
                              header="SubType"
                              sortable
                              filter
                              style={{ minWidth: "10rem" }}
                            />
                            <Column
                              field="subject"
                              header="Subject"
                              sortable
                              filter
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="reminder"
                              header="Reminder"
                              sortable
                              filter
                              style={{ minWidth: "8rem" }}
                              body={reminderTemplate}
                            />
                            <Column
                              field="reminderDate"
                              header="Reminder Date"
                              sortable
                              filter
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="startDate"
                              header="Start Date"
                              sortable
                              filter
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="endDate"
                              header="End Date"
                              sortable
                              filter
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="completed"
                              header="Completed"
                              body={completedCheckboxTemplate}
                              style={{ minWidth: "8rem" }}
                            />
                            <Column
                              field="private"
                              header="Private"
                              body={privateCheckboxTemplate}
                              style={{ minWidth: "8rem" }}
                            />
                            <Column
                              field="user_ids"
                              header="User ID"
                              sortable
                              filter
                              style={{ minWidth: "10rem" }}
                              body={rowData => (
                                <span>
                                  {Array.isArray(rowData.user_ids) && rowData.user_ids.length > 0
                                    ? rowData.user_ids.join(", ")
                                    : "None"}
                                </span>
                              )}
                            />
                          </DataTable>

                          <Dialog
                            visible={showConfirmDialog}
                            style={{ width: "450px" }}
                            header="Confirm Deletion"
                            modal
                            footer={
                              <div>
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  onClick={cancelDelete}
                                >
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-danger ms-2"
                                  onClick={confirmDelete}
                                >
                                  Delete
                                </button>
                              </div>
                            }
                            onHide={() => setShowConfirmDialog(false)}
                          >
                            <p>
                              Are you sure you want to delete{" "}
                              <strong>{selectedTableData[0]?.type}</strong>?
                            </p>
                          </Dialog>

                          <div className="card flex justify-content-center">
                            <Dialog
                              header={`APPOINTMENT${
                                selectedEvent?.created_by_name
                                  ? " - " + selectedEvent.created_by_name
                                  : ""
                              }`}
                              visible={interviewpop}
                              className="interview-popup"
                              style={{ width: "50vw" }}
                              onHide={() => {
                                if (!interviewpop) return
                                SetInterviewpop(false)
                              }}
                            >
                              <p className="bg-form">
                                <div className="mb-4">
                                  <Row className="mb-2">
                                    <Col xl={6}>
                                      <div className="p-field flex flex-column">
                                        <label htmlFor="interview">Type</label>
                                        <InputText
                                          id="interview"
                                          aria-describedby="username-help"
                                          value={interview}
                                          placeholder="Interview"
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col xl={6}>
                                      <div className="p-field flex flex-column">
                                        <label htmlFor="integer" className=" block">
                                          Sub-Type
                                        </label>
                                        <InputText
                                          id="integer"
                                          value={subtype}
                                          onChange={e => setSubtype(e.target.value)}
                                          placeholder="Subtype"
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xl={6}>
                                      <Row className="mb-2">
                                        <Col xl={6}>
                                          <div className="p-field flex-auto">
                                            <label
                                              htmlFor="buttondisplay"
                                              className="block"
                                            >
                                              Start date
                                            </label>
                                            <Calendar
                                              value={startdate}
                                              onChange={e => setStartdate(e.value)}
                                              showIcon
                                              dateFormat="yy-mm-dd"
                                            />
                                          </div>
                                        </Col>
                                        <Col xl={6}>
                                          <div className="p-field flex-auto">
                                            <label
                                              htmlFor="buttondisplay"
                                              className="block"
                                            >
                                              Time
                                            </label>
                                            <Calendar
                                              value={starttime}
                                              onChange={e => setStarttime(e.value)}
                                              showIcon
                                              timeOnly
                                              icon={() => (
                                                <i className="pi pi-clock" />
                                              )}
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col xl={6}>
                                      <Row className="mb-2">
                                        <Col xl={6}>
                                          <div className="flex-auto">
                                            <label
                                              htmlFor="buttondisplay"
                                              className="block"
                                            >
                                              End date
                                            </label>
                                            <Calendar
                                              value={enddate}
                                              onChange={e => setEnddate(e.value)}
                                              showIcon
                                              dateFormat="yy-mm-dd"
                                            />
                                          </div>
                                        </Col>
                                        <Col xl={6}>
                                          <div className="flex-auto">
                                            <label
                                              htmlFor="buttondisplay"
                                              className="block"
                                            >
                                              Time
                                            </label>
                                            <Calendar
                                              value={endtime}
                                              onChange={e => setEndtime(e.value)}
                                              showIcon
                                              timeOnly
                                              icon={() => (
                                                <i className="pi pi-clock" />
                                              )}
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                </div>
                                <div className="mb-4">
                                  <Row className="mb-2">
                                    <Col lg={6}>
                                      <div className="field">
                                        <label htmlFor="job" className="block mb-0">
                                          Job
                                        </label>
                                        <div
                                          className="d-flex align-items-center"
                                          style={{ position: "relative" }}
                                        >
                                          <InputText
                                            id="job"
                                            value={selectedJobTitles}
                                            onChange={e =>
                                              setSelectedJobTitles(e.target.value)
                                            }
                                            placeholder="Enter Job"
                                            className="w-full"
                                            style={{ paddingRight: "2rem" }}
                                            readOnly
                                          />
                                          <i
                                            className="pi pi-chevron-down"
                                            onClick={handleIconClick}
                                            style={{
                                              position: "absolute",
                                              right: "10px",
                                              top: "50%",
                                              transform: "translateY(-50%)",
                                              cursor: "pointer",
                                            }}
                                          ></i>
                                        </div>
                                        <Dialog
                                          header="Job Details"
                                          visible={jobDetailsVisible}
                                          onHide={() => setJobDetailsVisible(false)}
                                          style={{ width: "40vw" }}
                                          breakpoints={{
                                            "960px": "75vw",
                                            "641px": "100vw",
                                          }}
                                          className="cand-details"
                                        >
                                          <Row>
                                            <Col lg={12}>
                                              <div
                                                className="p-inputgroup mb-3"
                                                style={{ position: "relative" }}
                                              >
                                                <InputText
                                                  placeholder="Search Jobs"
                                                  value={jobSearchText}
                                                  onInput={handleJobSearch}
                                                  style={{ paddingRight: "2rem" }}
                                                />
                                                <i
                                                  className="pi pi-search"
                                                  style={{
                                                    position: "absolute",
                                                    right: "10px",
                                                    top: "49%",
                                                    transform: "translateY(-50%)",
                                                  }}
                                                ></i>
                                              </div>
                                            </Col>
                                          </Row>
                                          <DataTable
                                            value={filteredJobs}
                                            paginator
                                            first={jobLazyParams.page * jobLazyParams.rows}
                                            rows={jobLazyParams.rows}
                                            totalRecords={totalRecordsJobs}
                                            onPage={onJobPageChange}
                                            // selection={selectedJobs}
                                            // onSelectionChange={e =>
                                            //   setSelectedJobs(e.value || [])
                                            // }
                                            lazy
                                            dataKey="job_id"
                                            rowsPerPageOptions={[5, 10, 25]}
                                            size="small"
                                            filters={jobFilters}
                                            filterDisplay="row"
                                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                          >
                                            {/* <Column
                                              selectionMode="multiple"
                                              style={{ width: "3em" }}
                                            /> */}
                                      
                                            <Column
                                              field="job_title"
                                              header="Job Title"
                                            />
                                            <Column
                                              field="hiring_manager_name"
                                              header="Contact"
                                            />
                                          </DataTable>
                                          <div className="d-flex mt-3">
                                            <button
                                              type="button"
                                              className="btn btn-primary me-2 btn-main"
                                              onClick={handleSaveTitle}
                                            >
                                              Ok
                                            </button>
                                            <button
                                              type="button"
                                              className="btn btn-primary btn-main"
                                              onClick={handleRefresh}
                                            >
                                              Refresh
                                            </button>
                                          </div>
                                        </Dialog>
                                      </div>
                                    </Col>
                                    <Col xl={6}>
                                      <div className="field">
                                        <label
                                          htmlFor="contact"
                                          className="block mb-0"
                                        >
                                          Contact
                                        </label>
                                        <div
                                          className="d-flex align-items-center"
                                          style={{ position: "relative" }}
                                        >
                                          <InputText
                                            id="contact"
                                            value={selectedContactNames}
                                            onChange={e =>
                                              setSelectedContactNames(e.target.value)
                                            }
                                            placeholder="Enter Contact"
                                            className="w-full"
                                            style={{ paddingRight: "2rem" }}
                                            readOnly
                                          />
                                          <i
                                            className="pi pi-chevron-down"
                                            onClick={handleContactIconClick}
                                            style={{
                                              position: "absolute",
                                              right: "10px",
                                              top: "50%",
                                              transform: "translateY(-50%)",
                                              cursor: "pointer",
                                            }}
                                          ></i>
                                        </div>
                                        <Dialog
                                          header="Contact Details"
                                          visible={contactDetailsVisible}
                                          onHide={() =>
                                            setContactDetailsVisible(false)
                                          }
                                          style={{ width: "40vw" }}
                                          breakpoints={{
                                            "960px": "75vw",
                                            "641px": "100vw",
                                          }}
                                          className="contact-details"
                                        >
                                          <Row>
                                            <Col lg={12}>
                                              <div
                                                className="p-inputgroup mb-3"
                                                style={{ position: "relative" }}
                                              >
                                                <InputText
                                                  placeholder="Search Contacts"
                                                  value={contactSearchText}
                                                  onInput={handleContactSearch}
                                                  style={{ paddingRight: "2rem" }}
                                                />
                                                <i
                                                  className="pi pi-search"
                                                  style={{
                                                    position: "absolute",
                                                    right: "10px",
                                                    top: "49%",
                                                    transform: "translateY(-50%)",
                                                  }}
                                                ></i>
                                              </div>
                                            </Col>
                                          </Row>
                                          <DataTable
                                            value={filteredContactsList}
                                            paginator
                                            first={contactLazyParams.page * contactLazyParams.rows}
                                            rows={contactLazyParams.rows}
                                            totalRecords={totalRecordsContacts}
                                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                            onPage={onContactPageChange}
                                            // selection={selectedContacts}
                                            // onSelectionChange={e =>
                                            //   setSelectedContacts(e.value || [])
                                            // }
                                            dataKey="id"
                                            rowsPerPageOptions={[5, 10, 25]}
                                            size="small"
                                            filters={contactFilters}
                                            filterDisplay="row"
                                            lazy
                                          >
                                            {/* <Column
                                              selectionMode="multiple"
                                              style={{ width: "3em" }}
                                            /> */}
                                            
                                            <Column
                                              field="first_name"
                                              header="Contact Name"
                                            />
                                            <Column field="email" header="Email" />
                                          </DataTable>
                                          <div className="d-flex mt-3">
                                            <button
                                              type="button"
                                              className="btn btn-primary me-2 btn-main"
                                              onClick={handleSaveContact}
                                            >
                                              Ok
                                            </button>
                                            <button
                                              type="button"
                                              className="btn btn-primary btn-main"
                                              onClick={handleContactRefresh}
                                            >
                                              Refresh
                                            </button>
                                          </div>
                                        </Dialog>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col xl={6}>
                                      <div className="field">
                                        <label
                                          htmlFor="candidate"
                                          className="block mb-0"
                                        >
                                          Candidate
                                        </label>
                                        <div
                                          className="d-flex align-items-center"
                                          style={{ position: "relative" }}
                                        >
                                          <InputText
                                            id="candidate"
                                            value={selectedCandidateNames}
                                            onChange={e =>
                                              setSelectedCandidateNames(
                                                e.target.value
                                              )
                                            }
                                            placeholder="Enter Candidate"
                                            className="w-full"
                                            style={{ paddingRight: "2rem" }}
                                            readOnly
                                          />
                                          <i
                                            className="pi pi-chevron-down"
                                            onClick={handleCandidateIconClick}
                                            style={{
                                              position: "absolute",
                                              right: "10px",
                                              top: "50%",
                                              transform: "translateY(-50%)",
                                              cursor: "pointer",
                                            }}
                                          ></i>
                                        </div>
                                        <Dialog
                                          header="Candidate Details"
                                          visible={candidateDetailsVisible}
                                          onHide={() =>
                                            setCandidateDetailsVisible(false)
                                          }
                                          style={{ width: "40vw" }}
                                          breakpoints={{
                                            "960px": "75vw",
                                            "641px": "100vw",
                                          }}
                                          className="candidate-details"
                                        >
                                          <Row>
                                            <Col lg={12}>
                                              <div
                                                className="p-inputgroup mb-3"
                                                style={{ position: "relative" }}
                                              >
                                                <InputText
                                                  placeholder="Search Candidates"
                                                  value={candidateSearchText}
                                                  onInput={handleCandidateSearch}
                                                  style={{ paddingRight: "2rem" }}
                                                />
                                                <i
                                                  className="pi pi-search"
                                                  style={{
                                                    position: "absolute",
                                                    right: "10px",
                                                    top: "49%",
                                                    transform: "translateY(-50%)",
                                                  }}
                                                ></i>
                                              </div>
                                            </Col>
                                          </Row>
                                          <DataTable
                                            value={filteredCandidatesList}
                                            paginator
                                            first={candidateLazyParams.page * candidateLazyParams.rows}
                                            rows={candidateLazyParams.rows}
                                            totalRecords={totalRecordsCandidates}
                                            // selection={selectedCandidates}
                                            // onSelectionChange={e =>
                                            //   setSelectedCandidates(e.value || [])
                                            // }
                                            dataKey="candidate_id"
                                            rowsPerPageOptions={[5, 10, 25]}
                                            size="small"
                                            filters={candidateFilters}
                                            filterDisplay="row"
                                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                            onPage={onCandidatePageChange}
                                            lazy
                                          >
                                            {/* <Column
                                              selectionMode="multiple"
                                              style={{ width: "3em" }}
                                            /> */}
                                            {/* <Column
                                              field="candidate_id"
                                              header="Candidate ID"
                                            /> */}
                                            <Column
                                              field="first_name"
                                              header="Candidate Name"
                                            />
                                            <Column field="email" header="Email" />
                                          </DataTable>
                                          <div className="d-flex mt-3">
                                            <button
                                              type="button"
                                              className="btn btn-primary me-2 btn-main"
                                              onClick={handleSaveCandidate}
                                            >
                                              Ok
                                            </button>
                                            <button
                                              type="button"
                                              className="btn btn-primary btn-main"
                                              onClick={handleCandidateRefresh}
                                            >
                                              Refresh
                                            </button>
                                          </div>
                                        </Dialog>
                                      </div>
                                    </Col>
                                    <Col xl={6}>
                                      <div className="p-field flex flex-column">
                                        <label htmlFor="subject">Subject</label>
                                        <InputText
                                          id="subject"
                                          onChange={e => setSubject(e.target.value)}
                                          value={subject}
                                          placeholder="Subject"
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row className="mb-2 mt-3">
                                    <Col xl={12}>
                                      <div className="p-field flex flex-column">
                                        <label htmlFor="description">
                                          Description
                                        </label>
                                        <InputTextarea
                                          id="description"
                                          className="w-full"
                                          value={popTextares}
                                          onChange={e =>
                                            setPopTextares(e.target.value)
                                          }
                                          placeholder="Interview Test"
                                          rows={3}
                                          cols={20}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                                <div>
                                  <Row className="mb-2">
                                    <Col xl={6}>
                                      <div className="p-field">
                                        <label htmlFor="username">
                                          Auto Followup
                                        </label>
                                        <Dropdown
                                          value={followup}
                                          onChange={e => setFollowup(e.value)}
                                          options={followupOptions}
                                          optionLabel="name"
                                          placeholder="Select a Followup Interval"
                                          className="w-full search-option"
                                        />
                                      </div>
                                    </Col>
                                    <Col xl={6}>
                                      <Row>
                                        <Col xl={6}>
                                          <div className="p-field flex flex-column">
                                            <label htmlFor="username">Repeat</label>
                                            <Dropdown
                                              value={repeat}
                                              onChange={e => setRepeat(e.value)}
                                              options={repeatOptions}
                                              optionLabel="name"
                                              placeholder="Select a Repeat Option"
                                              className="w-full search-option"
                                            />
                                          </div>
                                        </Col>
                                        <Col xl={6}>
                                          <div className="p-field flex flex-column">
                                            <label htmlFor="Rusername">
                                              Reminder
                                            </label>
                                            <Dropdown
                                              value={reminder}
                                              onChange={e => setReminder(e.value)}
                                              options={reminderOptions}
                                              optionLabel="name"
                                              placeholder="Select a Reminder"
                                              className="w-full search-option"
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg={6}>
                                      <Row>
                                        <Col xl={6}>
                                          <div className="p-field flex flex-column">
                                            <label For="Priority" className=" block">
                                              Priority
                                            </label>
                                            <Dropdown
                                              value={priority}
                                              onChange={e => setPriority(e.value)}
                                              options={typeInterview}
                                              optionLabel="name"
                                              placeholder="Priority"
                                              className="w-full search-option"
                                            />
                                          </div>
                                        </Col>
                                        <Col xl={6}>
                                          <Row className="mt-2">
                                            <Col xl={6}>
                                              <div className="d-flex align-items-center mt-4">
                                                <Checkbox
                                                  inputId="checkbox"
                                                  checked={popchecked}
                                                  onChange={handlePopupCheckbox}
                                                />
                                                <label
                                                  htmlFor="username"
                                                  className="ms-1 mt-2"
                                                >
                                                  Completed
                                                </label>
                                              </div>
                                            </Col>
                                            <Col xl={6}>
                                              <div className="d-flex align-items-center mt-4">
                                                <Checkbox
                                                  inputId="checkbox"
                                                  checked={popchecked2}
                                                  onChange={handlePopupCheckbox2}
                                                />
                                                <label
                                                  htmlFor="username"
                                                  className="ms-1 mt-2"
                                                >
                                                  Private
                                                </label>
                                              </div>
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                </div>
                                <Row className="">
                                  <Col xl={12}>
                                    <div className="d-flex justify-content-end">
                                      <button
                                        type="button"
                                        className="btn btn-primary waves-light btn btn-primary me-2 btn-main"
                                        onClick={handleSave}
                                      >
                                        <i className="pi pi-save me-1"></i>
                                        Save
                                      </button>
                                      <button
                                        color="primary"
                                        className="btn btn-primary waves-light me-2 cancel-outlinebtn"
                                      >
                                        <i className="pi pi-times me-1"></i>
                                        Cancel
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </p>
                            </Dialog>
                            <Dialog
                              header={`APPOINTMENT${
                                selectedEvent?.created_by_name
                                  ? " - " + selectedEvent.created_by_name
                                  : ""
                              }`}
                              visible={interviewpop1}
                              className="interview-popup"
                              style={{ width: "50vw" }}
                              onHide={() => SetInterviewpop1(false)}
                            >
                              <p className="bg-form">
                                <div className="mb-4">
                                  <Row className="mb-2">
                                    <Col xl={6}>
                                      <div className="p-field flex flex-column">
                                        <label htmlFor="interview">Type</label>
                                        <InputText
                                          id="interview"
                                          value={interview}
                                          placeholder="Interview"
                                          disabled
                                        />
                                      </div>
                                    </Col>
                                    <Col xl={6}>
                                      <div className="p-field flex flex-column">
                                        <label htmlFor="subtype" className="block">
                                          Sub-Type
                                        </label>
                                        <InputText
                                          id="subtype"
                                          value={subtype || ""}
                                          placeholder="Subtype"
                                          disabled
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xl={6}>
                                      <Row className="mb-2">
                                        <Col xl={6}>
                                          <div className="p-field flex-auto">
                                            <label
                                              htmlFor="startdate"
                                              className="block"
                                            >
                                              Start date
                                            </label>
                                            <Calendar
                                              value={startdate}
                                              showIcon
                                              disabled
                                              dateFormat="yy-mm-dd"
                                            />
                                          </div>
                                        </Col>
                                        <Col xl={6}>
                                          <div className="p-field flex-auto">
                                            <label
                                              htmlFor="starttime"
                                              className="block"
                                            >
                                              Time
                                            </label>
                                            <Calendar
                                              value={starttime}
                                              showIcon
                                              timeOnly
                                              disabled
                                              icon={() => (
                                                <i className="pi pi-clock" />
                                              )}
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col xl={6}>
                                      <Row className="mb-2">
                                        <Col xl={6}>
                                          <div className="flex-auto">
                                            <label
                                              htmlFor="enddate"
                                              className="block"
                                            >
                                              End date
                                            </label>
                                            <Calendar
                                              value={enddate}
                                              showIcon
                                              disabled
                                              dateFormat="yy-mm-dd"
                                            />
                                          </div>
                                        </Col>
                                        <Col xl={6}>
                                          <div className="flex-auto">
                                            <label
                                              htmlFor="endtime"
                                              className="block"
                                            >
                                              Time
                                            </label>
                                            <Calendar
                                              value={endtime}
                                              showIcon
                                              timeOnly
                                              disabled
                                              icon={() => (
                                                <i className="pi pi-clock" />
                                              )}
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                </div>
                                <div className="mb-4">
                                  <Row className="mb-2">
                                    <Col xl={6}>
                                      <div className="field">
                                        <label htmlFor="job" className="block mb-0">
                                          Job
                                        </label>
                                        <div
                                          className="d-flex align-items-center"
                                          style={{ position: "relative" }}
                                        >
                                          <InputText
                                            id="job"
                                            value={selectedJobTitles}
                                            placeholder="Enter Job"
                                            className="w-full"
                                            style={{ paddingRight: "2rem" }}
                                            disabled
                                          />
                                          <i
                                            className="pi pi-chevron-down"
                                            style={{
                                              position: "absolute",
                                              right: "10px",
                                              top: "50%",
                                              transform: "translateY(-50%)",
                                            }}
                                          ></i>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xl={6}>
                                      <div className="field">
                                        <label
                                          htmlFor="contact"
                                          className="block mb-0"
                                        >
                                          Contact
                                        </label>
                                        <div
                                          className="d-flex align-items-center"
                                          style={{ position: "relative" }}
                                        >
                                          <InputText
                                            id="contact"
                                            value={selectedContactNames}
                                            placeholder="Enter Contact"
                                            className="w-full"
                                            style={{ paddingRight: "2rem" }}
                                            disabled
                                          />
                                          <i
                                            className="pi pi-chevron-down"
                                            style={{
                                              position: "absolute",
                                              right: "10px",
                                              top: "50%",
                                              transform: "translateY(-50%)",
                                            }}
                                          ></i>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col xl={6}>
                                      <div className="field">
                                        <label
                                          htmlFor="candidate"
                                          className="block mb-0"
                                        >
                                          Candidate
                                        </label>
                                        <div
                                          className="d-flex align-items-center"
                                          style={{ position: "relative" }}
                                        >
                                          <InputText
                                            id="candidate"
                                            value={selectedCandidateNames}
                                            placeholder="Enter Candidate"
                                            className="w-full"
                                            style={{ paddingRight: "2rem" }}
                                            disabled
                                          />
                                          <i
                                            className="pi pi-chevron-down"
                                            style={{
                                              position: "absolute",
                                              right: "10px",
                                              top: "50%",
                                              transform: "translateY(-50%)",
                                            }}
                                          ></i>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xl={6}>
                                      <div className="p-field flex flex-column">
                                        <label htmlFor="subject">Subject</label>
                                        <InputText
                                          id="subject"
                                          value={subject}
                                          placeholder="Subject"
                                          disabled
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row className="mb-2 mt-3">
                                    <Col xl={12}>
                                      <div className="p-field flex flex-column">
                                        <label htmlFor="description">
                                          Description
                                        </label>
                                        <InputTextarea
                                          id="description"
                                          className="w-full"
                                          value={popTextares}
                                          placeholder="Interview Test"
                                          rows={3}
                                          cols={20}
                                          disabled
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                                <div>
                                  <Row className="mb-2">
                                    <Col xl={6}>
                                      <div className="p-field">
                                        <label htmlFor="followup">
                                          Auto Followup
                                        </label>
                                        <Dropdown
                                          value={followup}
                                          options={followupOptions}
                                          optionLabel="name"
                                          placeholder="Select a Followup Interval"
                                          className="w-full search-option"
                                          disabled
                                        />
                                      </div>
                                    </Col>
                                    <Col xl={6}>
                                      <Row>
                                        <Col xl={6}>
                                          <div className="p-field flex flex-column">
                                            <label htmlFor="repeat">Repeat</label>
                                            <Dropdown
                                              value={repeat}
                                              options={repeatOptions}
                                              optionLabel="name"
                                              placeholder="Select a Repeat Option"
                                              className="w-full search-option"
                                              disabled
                                            />
                                          </div>
                                        </Col>
                                        <Col xl={6}>
                                          <div className="p-field flex flex-column">
                                            <label htmlFor="reminder">Reminder</label>
                                            <Dropdown
                                              value={reminder}
                                              options={reminderOptions}
                                              optionLabel="name"
                                              placeholder="Select a Reminder"
                                              className="w-full search-option"
                                              disabled
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col lg={6}>
                                      <Row>
                                        <Col xl={6}>
                                          <div className="p-field flex flex-column">
                                            <label
                                              htmlFor="priority"
                                              className="block"
                                            >
                                              Priority
                                            </label>
                                            <Dropdown
                                              value={priority}
                                              options={typeInterview}
                                              optionLabel="name"
                                              placeholder="Priority"
                                              className="w-full search-option"
                                              disabled
                                            />
                                          </div>
                                        </Col>
                                        <Col xl={6}>
                                          <Row className="mt-2">
                                            <Col xl={6}>
                                              <div className="d-flex align-items-center mt-4">
                                                <Checkbox
                                                  inputId="checkbox"
                                                  checked={popchecked}
                                                  disabled
                                                />
                                                <label
                                                  htmlFor="checkbox"
                                                  className="ms-1 mt-2"
                                                >
                                                  Completed
                                                </label>
                                              </div>
                                            </Col>
                                            <Col xl={6}>
                                              <div className="d-flex align-items-center mt-4">
                                                <Checkbox
                                                  inputId="checkbox2"
                                                  checked={popchecked2}
                                                  disabled
                                                />
                                                <label
                                                  htmlFor="checkbox2"
                                                  className="ms-1 mt-2"
                                                >
                                                  Private
                                                </label>
                                              </div>
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col xl={6}>
                                      <label htmlFor="userid">User Id's</label>
                                      <Chips
                                        value={uniqueId}
                                        itemTemplate={customChip}
                                        className="w-full"
                                        disabled
                                      />
                                    </Col>
                                  </Row>
                                </div>
                                <Row className="">
                                  <Col xl={12}>
                                    <div className="d-flex justify-content-end">
                                      <button
                                        type="button"
                                        className="btn btn-primary waves-light me-2 cancel-outlinebtn"
                                        onClick={() => SetInterviewpop1(false)}
                                      >
                                        <i className="pi pi-times me-1"></i>
                                        Close
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </p>
                            </Dialog>
                          </div>
                        </div>
                      </section>
                    </Col>
                </Row>
             )}
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CalenderActive
